import { LitElement as u, unsafeCSS as h } from "lit";
import { property as t } from "lit/decorators.js";
import d from "../../shared/reset.style.css.js";
import { booleanType as p } from "../../utils/property-types.js";
import c from "./link.style.css.js";
import { template as y } from "./link.template.js";
var S = Object.defineProperty, e = (l, s, r, n) => {
  for (var o = void 0, a = l.length - 1, f; a >= 0; a--)
    (f = l[a]) && (o = f(s, r, o) || o);
  return o && S(s, r, o), o;
};
class i extends u {
  constructor() {
    super(...arguments), this.variant = "default", this.href = "#", this.label = "", this.icon = void 0, this.size = void 0, this.iconSize = "sm", this.iconPosition = "left", this.disabled = !1, this.download = !1, this.target = "_self", this.fontWeight = "inherit", this.fontSize = "inherit", this.fullWidth = !1, this.tooltipFixed = !1, this.forceViewport = !1;
  }
  static get styles() {
    return [h(d), h(c)];
  }
  updated(s) {
    s.has("variant") && queueMicrotask(() => {
      this.variant !== "default" && this.size === void 0 && (this.size = "lg");
    }), s.has("fontSize") && queueMicrotask(() => {
      var n;
      if (this.variant !== "default" || this.size !== void 0) return;
      const r = (n = this.shadowRoot) == null ? void 0 : n.querySelector("a.dss-link");
      r && (r.style.fontSize = this.fontSize);
    });
  }
  _getIconSize() {
    return this.size ? this.size === "lg" ? "md" : "sm" : this.iconSize;
  }
  checkTextTruncate(s) {
    if (!s) return;
    const r = s.target;
    let n = !1;
    const o = r.querySelector(".dss-link-text");
    n = o.scrollWidth > o.offsetWidth, r.setAttribute("data-truncated", n.toString());
  }
  focus(s) {
    var o;
    const r = (o = this.shadowRoot) == null ? void 0 : o.querySelector(".dss-link");
    if (!r) return;
    const n = { ...s, focusVisible: !0 };
    r.focus(n);
  }
  render() {
    return y(this);
  }
}
e([
  t({ type: String })
], i.prototype, "variant");
e([
  t({ type: String })
], i.prototype, "href");
e([
  t({ type: String })
], i.prototype, "label");
e([
  t({ type: String })
], i.prototype, "icon");
e([
  t({ type: String })
], i.prototype, "size");
e([
  t({ type: String })
], i.prototype, "iconSize");
e([
  t({ type: String })
], i.prototype, "iconPosition");
e([
  t(p)
], i.prototype, "disabled");
e([
  t(p)
], i.prototype, "download");
e([
  t({ type: String })
], i.prototype, "target");
e([
  t({ type: String })
], i.prototype, "fontWeight");
e([
  t({ type: String })
], i.prototype, "fontSize");
e([
  t(p)
], i.prototype, "fullWidth");
e([
  t(p)
], i.prototype, "tooltipFixed");
e([
  t(p)
], i.prototype, "forceViewport");
export {
  i as Link
};
//# sourceMappingURL=link.js.map
